





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Element, ElementType, ElementPatch, Product } from '@/models'
import ApiClient from '@/services/api-client'
import { MutationTypes } from '@/store/mutation-types'
import {
  ROLE_EDITOR
} from '@/utils/constants'

@Component({
  components: {}
})
export default class StructureWebpackFields extends Vue {
  @Prop({ required: true, type: Object }) product: Product
  @Prop({ required: true, type: Object }) element: Element

  public ROLE_EDITOR = ROLE_EDITOR

  private reviewEditionInter = false
  private reviewMarketingInter = false

  created() {
    this.resetFromOrigin()
  }

  @Watch('element', { deep: true })
  onElementChanged() {
    this.resetFromOrigin()
  }

  @Watch('reviewEditionInter')
  onReviewEditionInterChanged() {
    this.updateField()
  }

  @Watch('reviewMarketingInter')
  onReviewMarketingInterChanged() {
    this.updateField()
  }

  get typeSelected() {
    if (this.element.type === '') {
      return null
    }
    return this.$store.getters.elementTypes.find((item: ElementType) => item.codeId === this.element.type)
  }

  get notReviewEdition() {
    return !this.element.metadata || !this.element.metadata.reviewEdition || this.element.metadata.reviewEdition === false
  }

  get notReviewMarketing() {
    return !this.element.metadata || !this.element.metadata.reviewMarketing || this.element.metadata.reviewMarketing === false
  }

  private resetFromOrigin() {
    this.reviewEditionInter = this.element.metadata.reviewEdition
    this.reviewMarketingInter = this.element.metadata.reviewMarketing
  }

  private updateField() {
    if (!this.reviewEditionInter && this.notReviewEdition && !this.reviewMarketingInter && this.notReviewMarketing) {
      return
    } else if (this.reviewEditionInter === this.element.metadata.reviewEdition && this.reviewMarketingInter === this.element.metadata.reviewMarketing) {
      return
    }
    const updateElement: ElementPatch = {
      metadata: this.element.metadata
    }
    if (updateElement.metadata) {
      if (this.reviewEditionInter !== this.element.metadata.reviewEdition) {
        updateElement.metadata.reviewEdition = this.reviewEditionInter
      } else if (this.reviewMarketingInter !== this.element.metadata.reviewMarketing) {
        updateElement.metadata.reviewMarketing = this.reviewMarketingInter
      }
    } else {
      if (this.reviewEditionInter !== this.element.metadata.reviewEdition) {
        updateElement.metadata = { reviewEdition: this.reviewEditionInter }
      } else if (this.reviewMarketingInter !== this.element.metadata.reviewMarketing) {
        updateElement.metadata = { reviewMarketing: this.reviewMarketingInter }
      }
    }
    this.$store.commit(MutationTypes.SET_LOADING, true)
    ApiClient.updateElement(updateElement, this.element.id)
      .then((element: Element) => {
        this.$emit('elementUpdated', element)
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
      .catch((ex: Error) => {
        console.log('Error form', ex)
        this.$store.commit(MutationTypes.SET_LOADING, false)
        alert(`Error: ${ex.message}`)
      })
  }

  private showField(field: string) {
    if (!field || !this.typeSelected || !this.typeSelected.metadataAllowed) {
      return false
    }

    const fieldsToFind = field.split(',')
    let showField = false
    for (const fieldToFind of fieldsToFind) {
      if (this.typeSelected.metadataAllowed.split(',').includes(fieldToFind)) {
        showField = true
        break
      }
    }
    return showField
  }
}
